// extracted by mini-css-extract-plugin
module.exports = {"info":"_a45ad41"};